import { render, staticRenderFns } from "./SummerSchool.vue?vue&type=template&id=3bee04ec&scoped=true&"
import script from "./SummerSchool.vue?vue&type=script&lang=js&"
export * from "./SummerSchool.vue?vue&type=script&lang=js&"
import style0 from "./SummerSchool.vue?vue&type=style&index=0&id=3bee04ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee04ec",
  null
  
)

export default component.exports